import React from 'react'
import PropTypes from 'prop-types'
import './LogoComponent.css'

const LogoComponent = (props) => {
	return (
		<div className="LogoComponent">
			<img src={props.image} alt=''/>
		</div>
	)
}

LogoComponent.propTypes = {
	image: PropTypes.string.isRequired
}

export default LogoComponent


// WEBPACK FOOTER //
// ./src/components/LogoComponent/LogoComponent.js